/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Backbone = require('backbone');

var GetDocumentTypesByDepartment = require('common/services/GetDocumentTypesByDepartment');
var GetAllFilingGenericSubmissionTypes = require('../../common/services/GetAllFilingGenericSubmissionTypes');
var GetGenericSubmissionFiling = require('../services/GetGenericSubmissionFiling');
var GetEntityExternalUsersByAccessLevel = require('../../common/services/GetEntityExternalUsersByAccessLevel');

var GenericSubmissionFiling = require('../forms/GenericSubmissionFiling');

module.exports = {
  event: 'build:filing:generic-submission',

  channel: 'dp:filing',

  builder: function(config) {
    var defer = $.Deferred();
    var currFilingId = config.filingId;
    var taskId = config.taskId;
    $.when(
      GetGenericSubmissionFiling(currFilingId),
      GetAllFilingGenericSubmissionTypes(),
      GetDocumentTypesByDepartment('DEPOSITORY'),
      GetEntityExternalUsersByAccessLevel({ entityId: config.entityId, accessLevel: 1 })
    )
      .done(function(filingContent, submissionTypes, documentTypes, filers) {
        defer.resolve(
          new GenericSubmissionFiling({
            isReadOnly: config.isReadOnly,
            mode: config.mode || 'ext-new', // Possible values of mode: 'ext-new', 'int-new', 'resubmit', 'print', 'int-expand'
            model: new Backbone.Model({
              filingId: currFilingId,
              filingContent: filingContent,
              submissionTypes: submissionTypes,
              documentTypes: documentTypes,
              taskId: taskId,
              lawyers: filers
            })
          })
        );
      })
      .fail(function(err) {
        defer.reject(err);
      });

    return defer.promise();
  }
};
